<!-- <div class="error-container" [class.hide]="_hide">
  <mat-error>
  
  </mat-error>
</div> -->

<div class="invalid-feedback">
  {{_text}}
</div>
<!-- <div class="invalid-tooltip">
  {{_text}}
</div> -->